// Where you were (Ryan, Nov 1 2026: "the Back button takes you to random places").
//
// Every desktop page records itself here as you move about. Back then goes to the last DIFFERENT
// page you were on — not the browser's previous history entry, which is often a tab click, a
// redirect or a page that replaced itself, and not a fixed place like the Projects list.
//
// A page is its path. Its tabs and panes ride along in the search (?pane=bigpicture) so coming
// back lands on the same pane, but moving between tabs on one page is not a step of its own.
// Going back to the page before pops the trail, so Back, Back, Back walks home.
const KEY = 'titan_trail';   // per browser tab (sessionStorage), newest last, at most 40

const read = () => { try { const t = JSON.parse(sessionStorage.getItem(KEY) || '[]'); return Array.isArray(t) ? t : []; } catch { return []; } };
const write = t => { try { sessionStorage.setItem(KEY, JSON.stringify(t.slice(-40))); } catch { /* private window — Back falls back to the browser's */ } };
const pathOf = entry => String(entry || '').split('?')[0];

// Call on every location change of a desktop page.
export function recordPage(location) {
  if (!location || !location.pathname) return;
  const here = location.pathname + (location.search || '');
  const t = read();
  const n = t.length;
  if (n && pathOf(t[n - 1]) === location.pathname) t[n - 1] = here;                 // same page, a newer tab or pane
  else if (n >= 2 && pathOf(t[n - 2]) === location.pathname) { t.pop(); t[n - 2] = here; }   // went back one page
  else t.push(here);
  write(t);
}

// The page before this one, with its tab or pane — or null when this is the first page of the tab.
export function previousPage() {
  const t = read();
  return t.length >= 2 ? t[t.length - 2] : null;
}

// Back: the page before this one; failing that the page given (a page's natural home), failing
// that the browser's own back.
export function goBack(navigate, fallback = null) {
  const prev = previousPage();
  if (prev) navigate(prev);
  else if (fallback) navigate(fallback);
  else navigate(-1);
}
